import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Error404 = () => {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">404</div>
        <p className="lead mt-4 text-800 font-sans-serif fw-semibold">
          A página que você está procurando não foi encontrada.
        </p>
        <hr />
        <p>
          Confira se o endereço está correto e que a página não foi movida. Se
          você acha que isso é um erro, por favor
          <a href="mailto:contato@mspworks.com.br" className="ms-1">
            contate-nos
          </a>
          .
        </p>
        <Link className="btn btn-primary btn-sm mt-3" to="/">
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Voltar para página inicial
        </Link>
      </Card.Body>
    </Card>
  );
};

export default Error404;
